import { TPageName } from '../../../../shared/common/types/applicationContext';

require('../../../constants/criticalResources/common');

export async function importApp(pageName: TPageName) {
  switch (pageName) {
    case 'regions': {
      return (await import('../../../../shared/regions/containers/RegionsApp')).RegionsApp;
    }
    case 'start': {
      return (await import('../../../../shared/startPage/containers/MainApp')).MainApp;
    }

    default:
      throw new Error('Unknown context.custom.pageName');
  }
}
